export default __webpack_public_path__ + "static/media/voroshasthol.6a94992e.png";